import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TaxonomiesLookupComponent } from './taxonomies-lookup.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [TaxonomiesLookupComponent],
  exports: [TaxonomiesLookupComponent]
})
export class TaxonomiesLookupModule { }
